import React, { useContext, useEffect, useState, useCallback } from "react";
import { NavLink } from "react-router-dom";
import Axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import "./adminNavbar.css";

const API = process.env.REACT_APP_API_URL;

// شريط إدارة يظهر فقط للمدير العام (SUPER_ADMIN) أسفل الشريط الرئيسي
const AdminNavbar = () => {
  const { user } = useContext(AuthContext);
  const [pendingCount, setPendingCount] = useState(0);

  const isSuperAdmin = user?.role === "SUPER_ADMIN";

  const fetchPendingCount = useCallback(async () => {
    if (!isSuperAdmin) return;
    try {
      const res = await Axios.get(
        `${API}/product/getPendingQuantityCount.php`
      );
      if (res.data.status === "success") {
        setPendingCount(res.data.pending_count || 0);
      }
    } catch (err) {
      /* تجاهل */
    }
  }, [isSuperAdmin]);

  // 🔔 تحديث عدد الطلبات المعلّقة دورياً (كل 30 ثانية)
  useEffect(() => {
    if (!isSuperAdmin) return;
    fetchPendingCount();
    const t = setInterval(fetchPendingCount, 30000);
    // تحديث عند العودة للتبويب
    const onFocus = () => fetchPendingCount();
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(t);
      window.removeEventListener("focus", onFocus);
    };
  }, [isSuperAdmin, fetchPendingCount]);

  if (!user || !isSuperAdmin) return null;

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-wrapper">
        <span className="admin-navbar-label">لوحة المدير العام</span>
        <ul className="admin-navbar-links">
          <li>
            <NavLink
              to="/admin/users"
              className={({ isActive }) =>
                isActive ? "admin-link active" : "admin-link"
              }
            >
              المستخدمون
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/branches"
              className={({ isActive }) =>
                isActive ? "admin-link active" : "admin-link"
              }
            >
              الفروع
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/quantity-requests"
              className={({ isActive }) =>
                isActive
                  ? "admin-link admin-link-badge active"
                  : "admin-link admin-link-badge"
              }
            >
              طلبات الكمية
              {pendingCount > 0 && (
                <span className="admin-nav-badge">{pendingCount}</span>
              )}
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AdminNavbar;
